import * as React from 'react';
import { History } from 'history';
import Model from './journalgroupdetail-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
  caption?: string;
  journalgroupId: number;
  actions?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
}

interface IState {
}

export default class JournalgroupdetailList extends React.Component<IProps, IState> {
  
  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} parentId={this.props.journalgroupId} caption={this.props.caption} endPointFilter={Model.endPointFilterList(this.props.journalgroupId)} url={(this.props.root || '') + Model.url} model={Model} actions={this.props.actions} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
